<template>
  <div class="settlement-container">
    <!-- 佣金总额部分 -->
    <div class="commission-section">
      <div class="settlement-header">
        <div class="header-title">
          <h1>{{ $t('enum.text_13') }}</h1>
          <p class="header-subtitle">{{ $t('settlement.subTitle') }}</p>
        </div>
        <div class="header-face-auth">
          <div v-if="faceAuthStatus === 'passed'"  class="auth-passed">
            <svg-icon icon-class="通过" class-name="icon"/>
            <span>{{ $t('settlement.faceAuthPassedTip') }}</span>
          </div>
          <div v-else class="auth-not-passed" @click="livenessCheck()">
            <svg-icon icon-class="叹号" class-name="icon"/>
            <span class="font-size-12">{{ $t('settlement.notFaceAuthTip') }}</span>
            <svg-icon icon-class="右箭头" class-name="icon" :style="{ color: '#f37d10' }"/>
          </div>
        </div>
      </div>
      <div class="settlement-content">
        <div class="commission-header">
          <h2 class="section-title">{{ $t('settlement.currentMonthTotal') }}<span v-if="commissionCcy">({{ commissionCcy }})</span></h2>
          <div class="update-time" v-if="lastTime">{{ $t('settlement.updatedAt') }} {{ $filters.date(lastTime,'YYYY-MM-DD HH:mm:ss') }}</div>
        </div>
        <div class="commission-content">
          <div class="commission-info" v-if="commissionStatus !== 'unpushed'">
            <div class="commission-amount">{{ $filters.currency(commissionAmount, '', '', 'amount') }}</div>
          </div>
          <div class="commission-actions">
            <el-button 
              v-if="commissionStatus === 'unconfirmed' || commissionStatus === 'rejected'" 
              type="primary" 
              @click="showFaceVerification(monthId)"
            >{{ $t('settlement.confirmBill') }}</el-button>
            <!-- <el-button 
              v-else-if="commissionStatus === 'confirmed'" 
              type="primary" 
              disabled
            >账单已确认</el-button> -->
            <el-button 
              v-else-if="commissionStatus === 'processing'" 
              type="primary" 
              disabled
            >{{ $t('settlement.pending') }}</el-button>
            <div class="commission-tip">
              <span v-if="commissionStatus === 'confirmed'">
                <svg-icon icon-class="通过" class-name="icon color-green"/> {{ $t('settlement.settled') }}：{{ $t('settlement.settledTip') }}
              </span>
              <span v-else-if="commissionStatus === 'unconfirmed' && faceAuthStatus === 'not_passed'">* {{ $t('settlement.faceTip') }}</span>
              <span v-else-if="commissionStatus === 'processing'">* {{ $t('settlement.pendingTip') }}</span>
              <span v-else-if="commissionStatus === 'rejected'" class="warning-tip">
                <el-icon class="warning-icon"><Warning /></el-icon> {{ $t('settlement.returned') }}：{{ settlementRemark }}
              </span>
              <span v-else-if="commissionStatus === 'unpushed'">* {{ $t('settlement.notPushedTip') }}</span>
            </div>
          </div>
        </div>
        <div class="commission-status" v-if="commissionStatus === 'unpushed'">
          <div class="empty-state">
            <img :src="emptyImg" alt="账单未推送" class="empty-icon" />
            <!-- <p>账单未推送</p> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 新的人脸认证弹框 -->
    <face-verification-dialog
      v-model:visible="faceVerificationVisible"
      @verify-complete="handleVerificationComplete"
    />

    <!-- 新增收款账户弹框 -->
    <!-- <add-account
      v-model="addAccountVisible"
      @submit="handleAccountSubmit"
      @close="handleAccountClose"
    /> -->
    
    <!-- 交易历史表格 -->
    <div class="table-section">
      <div class="table-container">
        <el-table
          v-loading="tbl.data.loading"
          :data="tbl.data.list"
          row-class-name="row-con"
        >
          <sr-tbl-column :columns="tbl.columns">
            <template #option="scope">
              <div class="action-buttons">
                <!-- 待结算 -->
                <el-button v-if="scope.row.settlementStatus === '0'" type="text" @click="showFaceVerification(scope.row.monthId, 'confirm')">{{ $t('settlement.settleBill') }}</el-button>
                
                <!-- 结算中或已结算 -->
                <el-button v-else-if="scope.row.settlementStatus === '1' || scope.row.settlementStatus === '3'" type="text" @click="handleBillAction(scope.row.monthId, 'view')">{{ $t('settlement.viewBill') }}</el-button>
                
                <!-- 已退回 -->
                <el-button v-else-if="scope.row.settlementStatus === '4'" type="text" @click="showFaceVerification(scope.row.monthId, 'edit')">{{ $t('settlement.settleBill') }}</el-button>
              </div>
            </template>
            <!-- <template #settlementTime="scope">
              <div>{{ scope.row.settlementTime }}</div>
            </template> -->
          </sr-tbl-column>
        </el-table>
        <sr-tbl-pagination
          v-model:current-page="tbl.pagination.currentPage"
          v-model:page-size="tbl.pagination.pageSize"
          :total="tbl.pagination.total"
          @fetchData="fetchData"
        >
        </sr-tbl-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import tableComp from "@/compositions/modules/table";
import SrTblColumn from "@/components/SrTblColumn";
import { components } from "@libs/ui";
import { reactive, toRefs, onMounted, computed } from "vue";
import { useI18n } from "@/plugins/i18n";
import { dataUtils } from "@libs/utils";
import { vab } from "@libs/utils";
import { SettlementColumns } from "@/domain/modules/settlement";
import SrUploadPlus from '@/components/sr-upload-plus';
import { listSettlement, getCurrentSettlementInfo, faceVerification } from '@/api/modules/settlement';
import router from '@/router'
import { useStore } from 'vuex'
import FaceVerificationDialog from '@/components/FaceVerificationDialog'
export default {
  components: {
    SrTblColumn,
    SrTblPagination: components.SrTblPagination,
    SrUploadPlus,
    FaceVerificationDialog
  },
  setup() {
    const store = useStore()
    const registerInfo= computed(() => store.state.auth.registerInfo);
    const scopedStates = reactive({
      regType: registerInfo.value.regType,
      emptyImg: require("@/assets/img/dashboard/empty.png"),
      commissionStatus: "",
      commissionAmount: null,
      commissionCcy: "",
      settlementRemark: '',
      dialogVisible: false,
      faceVerificationVisible: false, // 人脸认证弹框显示状态
      faceAuthStatus: "", // 'passed' 或 'not_passed'
      lastTime: '',
      monthId: '',
      selectedAccount: '', // 选中的收款账户
      accounts: [ // 收款账户列表
        // { id: 1, name: '张纸纸-香港汇丰银行****3242' },
        // { id: 2, name: '张纸纸-香港汇丰银行****3242' },
        // { id: 3, name: '张纸纸-香港汇丰银行****3242' }
      ],
      qrCertifyUrl: '', // 二维码认证链接
      addAccountVisible: false, // 新增收款账户弹框
      fileForIds: [
        { fileId: [], filename: '', initialFileList: [] }
      ],
      acctId: '',
      loading: false // 加载状态
    });
    const { t } = useI18n();
    const _initTable = initTable();
   
    const { FILE } = store.state.base.constant
    const showFaceVerification = (monthId) => {
      if (scopedStates.faceAuthStatus === 'passed') {
        // 人脸认证已通过，显示确认订单弹框
        console.log('scopedStates.lastTime', scopedStates.lastTime)
        handleBillAction(monthId, scopedStates.commissionStatus === 'unconfirmed' ? 'confirm' : 'edit')
      } else {
        // 未通过人脸认证，显示提示
        const confirmOptions = {
          confirmButtonText: t('settlement.proceed'),
          cancelButtonText:t('commonBtn.btn.cancel'),
          type: 'warning',
          showClose: true
        };
        
        // 当regType !== '2'时，显示取消按钮
        if (scopedStates.regType !== '2') {
          confirmOptions.cancelButtonText = t('settlement.skip');
          confirmOptions.distinguishCancelAndClose = true;
          confirmOptions.beforeClose = (action, instance, done) => {
            // 只有点击取消按钮时才执行跳过操作，点击关闭按钮时直接关闭
            if (action === 'cancel') {
              // 暂时跳过，直接跳转到确认账单页面
              handleBillAction(monthId, scopedStates.commissionStatus === 'unconfirmed' ? 'confirm' : 'edit');
            }
            done();
          };
        }
        
        vab.baseConfirm(
          t('settlement.notFaceAuthAlert'),
          t('settlement.tip'),
          confirmOptions,
          () => {
            // 立即认证逻辑
            livenessCheck()
          },
          () => {
            // 当显示取消按钮时，点击取消按钮的回调
            if (scopedStates.regType !== '2') {
              handleBillAction(monthId, scopedStates.commissionStatus === 'unconfirmed' ? 'confirm' : 'edit');
            }
          }
        );
      }
    };
    const livenessCheck = async () => {
      try {
        // 显示人脸验证弹框
        scopedStates.faceVerificationVisible = true;
      } catch (e) {
        console.log(e);
      } finally {
        // this.setAuthLoading(false)
      }
    }
    const confirmBill = () => {
      // vab.baseMessage("账单确认成功", "success");
      scopedStates.confirmDialogVisible = false;
      scopedStates.commissionStatus = "confirmed";
    };

    const handleAddAccount = () => {
      scopedStates.addAccountVisible = true;
    };

    const handleAccountSubmit = (formData) => {
      // 处理账户提交
      console.log('新增账户数据:', formData);
      // 这里可以调用API添加账户
      // vab.baseMessage("账户添加成功", "success");
    };

    const handleAccountClose = () => {
      scopedStates.addAccountVisible = false;
    };
    const fetchCurrentSettlement = async () => {
      scopedStates.loading = true;
      try {
        // Mock 数据
        // const mockRes = {
        //   header: {
        //     code: "0",
        //     message: "success",
        //     msgId: "123456",
        //     timeStamp: new Date().toISOString()
        //   },
        //   list: [
        //     {
        //       monthId: "2026-02",
        //       settlementAmt: 100000.00,
        //       settlementCcy: "USD",
        //       settlementStatus: "0", // 0: 待结算, 1: 已结算, 3: 结算中, 4: 已退回
        //       settlementTime: "2026-03-01 12:00:00"
        //     }
        //   ],
        //   pageInfo: {
        //     current: 1,
        //     size: 10
        //   }
        // };
        
        // const res = mockRes;
        const res = await getCurrentSettlementInfo();
        
        if (res) {
          scopedStates.commissionAmount = res.settlementAmt;
          scopedStates.commissionCcy = res.settlementCcy;
          scopedStates.settlementRemark = res.settlementRemark;
          scopedStates.lastTime = res.lastTime;
          scopedStates.monthId = res.monthId;
          
          // 根据结算状态更新 commissionStatus
          console.log('res.settlementStatus', res.settlementStatus)
          switch (res.settlementStatus) {
            case '0': // 待结算
              scopedStates.commissionStatus = 'unconfirmed';
              break;
            case '1': // 已结算
              scopedStates.commissionStatus = 'confirmed';
              break;
            case '3': // 结算中
              scopedStates.commissionStatus = 'processing';
              break;
            case '4': // 已退回
              scopedStates.commissionStatus = 'rejected';
              break;
            default:
              scopedStates.commissionStatus = 'unpushed';
          }
        } else {
          // 列表为空，显示账单未发送
          scopedStates.commissionStatus = 'unpushed';
        }
      } catch (error) {
        console.error('获取当前结算信息失败:', error);
        scopedStates.commissionStatus = 'unpushed';
      } finally {
        scopedStates.loading = false;
      }
    };

    const fetchData = () => {
      _initTable.fetchData();
    };

    const handleInvoiceAction = (row, action) => {
      vab.baseMessage(`发票${action === 'view' ? '查看' : '修改'}操作`);
    };

    const handleBillAction = (monthId, action) => {
      if (action === 'confirm' || action === 'view' || action === 'edit') {
        // 跳转到确认账单页面，添加查询参数
        router.push({
          path: '/settlement/confirm-order',
          query: { 
            mode: action,
            month: monthId, // 传递月份参数
            faceAuthStatus: scopedStates.faceAuthStatus // 传递人脸认证状态
          }
        })
      }
    };

    const handleVerificationComplete = () => {
      // 处理人脸认证完成
      scopedStates.faceAuthStatus = 'passed';
      vab.baseMessage('人脸认证成功', 'success');
      // 认证成功后，跳转到确认账单页面
      // handleBillAction({monthId: scopedStates.monthId}, scopedStates.commissionStatus === 'unconfirmed' ? 'confirm' : 'edit');
    };

    // 获取人脸认证状态
    const fetchFaceAuthStatus = async () => {
      try {
        const res = await faceVerification();
        scopedStates.faceAuthStatus = res.verifyResult ? 'passed' : 'not_passed';
      } catch (error) {
        console.error('获取人脸认证状态失败:', error);
        // 失败时默认设置为未通过
        scopedStates.faceAuthStatus = 'not_passed';
      }
    };

    onMounted(async () => {
      fetchCurrentSettlement();
      _initTable.fetchData();
      await fetchFaceAuthStatus();
    });

    return {
      t,
      ...toRefs(scopedStates),
      ...toRefs(_initTable),
      dataUtils,
      showFaceVerification,
      livenessCheck,
      confirmBill,
      fetchData,
      handleInvoiceAction,
      handleBillAction,
      handleAddAccount,
      handleAccountSubmit,
      handleAccountClose,
      handleVerificationComplete,
      FILE,
    };
  },
};

const initTable = () => {
  const { t } = useI18n();
  const { createTable } = tableComp();

  const tbl = createTable({ columns: SettlementColumns });
  console.log('tbl', tbl)
  const scopedMethods = {
    fetchData: async () => {
      tbl.data.loading = true;
      tbl.data.list = [];
      try {
        const res = await listSettlement({
          pageInfo: {
            current: tbl.pagination.currentPage,
            size: tbl.pagination.pageSize,
          }
        })
        tbl.data.list = res.list || []
        tbl.pagination.total = res.pageInfo.total || 0
        
      } finally {
        tbl.data.loading = false;
      }
    },
  };

  return { tbl, ...scopedMethods };
};
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.icon {
  width: 16px;
  height: 16px;
  font-size: 12px;
}
.icon.color-f37d10 {
  color: #F37D10;
}
.icon.color-green {
  color: #67c23a;
  margin-right: 4px;
}
.warning-tip {
  display: flex;
  align-items: center;
  gap: 5px;
}

.warning-icon {
  color: #f56c6c;
  // margin-right: 4px;
  font-size: 14px;
}
.icon.font-size-12 {
  font-size: 12px;
}
.settlement-container {
  padding: 20px;
  background-color: #fff;
  min-height: 100vh;
}

/* 标题区域 */
.settlement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}
.settlement-content {
  background-color: #fff;
}
.header-title {
  display: flex;
  align-items: baseline;
  gap: 13px;
}

.header-title h1 {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.header-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.upload-section {
  margin-top: 8px;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
  margin-bottom: 0;
}

.account-section {
  margin-top: 8px;
}

.account-actions {
  margin: 12px 0;
}

.add-account-btn {
  font-size: 14px;
  color: #409EFF;
  padding: 0;
}

.account-list {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px;
  max-height: 120px;
  overflow-y: auto;
}

.account-item {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.account-item:last-child {
  border-bottom: none;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.header-face-auth {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  z-index: 1;
}

.header-face-auth:hover {
  background-color: #f5f7fa;
}

.auth-passed {
  display: flex;
  align-items: center;
  color: #258655;
  font-size: 12px;
}

.auth-passed svg {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  color: #209B75;
}

.auth-not-passed {
  display: flex;
  align-items: center;
  color: #e6a23c;
  font-size: 14px;
  cursor: pointer;
}

.auth-not-passed svg:first-child {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  color: #e6a23c;
}

.auth-not-passed svg:last-child {
  width: 10px;
  height: 10px;
  margin-left: 6px;
  color: #909399;
}

.section-title {
  font-size: 14px;
  color: #606266;
}

.commission-section {
  background-color: #f4f9ff;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  min-height: 180px;
}

.commission-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}

.update-time {
  font-size: 14px;
  color: #909399;
}

.commission-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  padding-bottom: 10px;
}

.commission-info {
  display: flex;
  flex-direction: column;
  align-items: center;

  .commission-amount {
    font-size: 22px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 8px;
  }

  .commission-date {
    font-size: 16px;
    color: #909399;
  }
}

.commission-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.commission-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
  text-align: center;
}

.commission-status {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  .empty-icon {
    width: 107px;
    margin: 40px 0 20px;
  }

  p {
    color: #909399;
    font-size: 14px;
  }
}

.table-section {
  background-color: #fff;
}
.table-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 4px;

  .empty-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 160px auto;
    box-sizing: border-box;

    & > img {
      width: 190px;
      height: auto;
      display: block;
      margin-bottom: 38px;
    }
  }

  :deep(.row-con) {
    height: 57px;
  }
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
  :deep(.el-button) {
    padding: 0;
    font-size: 14px;
  }
}
.qrcode-container {
  width: 620px;
  display: flex;
  background: #f9f9f9;
  padding: 20px;
  align-items: center;
  .qrcode-img {
    width: 120px;
    height: 120px;
    background: #f1f1f1;
    img {
      width: 120px;
      height: 120px;
    }
  }
  .qrcode-tip {
    flex: 1;
    color: #999;
    font-size: 14px;
    line-height: 22px;
    padding-left: 40px;
    word-break: break-word;
    .qrcode-tip-title {
      margin-left: -15px;
      line-height: 30px;
      font-weight: bold;
    }
    .qrcode-tip-item {
      list-style-type: disc;
    }
  }
}
.face-verification {
  padding: 20px 0;

  .verification-tip {
    text-align: center;
    margin-bottom: 30px;

    p {
      margin-bottom: 8px;
    }

    .verification-amount {
      font-weight: 600;
      color: #409eff;
    }
  }

  .face-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;

    .face-icon {
      width: 100px;
      height: 100px;
      margin-bottom: 16px;
    }

    p {
      color: #909399;
      font-size: 14px;
    }
  }
}
</style>